import { render, staticRenderFns } from "./NsTextField.vue?vue&type=template&id=bb7fed14&scoped=true&"
import script from "./NsTextField.vue?vue&type=script&lang=js&"
export * from "./NsTextField.vue?vue&type=script&lang=js&"
import style0 from "./NsTextField.vue?vue&type=style&index=0&id=bb7fed14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7fed14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb7fed14')) {
      api.createRecord('bb7fed14', component.options)
    } else {
      api.reload('bb7fed14', component.options)
    }
    module.hot.accept("./NsTextField.vue?vue&type=template&id=bb7fed14&scoped=true&", function () {
      api.rerender('bb7fed14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/NsTextField.vue"
export default component.exports